import React from "react";
import {Modal,Button} from "react-bootstrap";

export default function DeleteProjectModal({show,setShow}){

return(

<Modal show={show} onHide={()=>setShow(false)} centered>

<Modal.Body className="text-center p-4">

<h5>Delete Project?</h5>

<p className="text-muted">
Are you sure you want to delete this project?
</p>

<Button variant="light" className="me-2" onClick={()=>setShow(false)}>
Cancel
</Button>

<Button className="btn-danger">
Delete
</Button>

</Modal.Body>

</Modal>

)

}